export default {
  CHROME_ON_IOS_PRIMARY_COPY: `Lo sentimos, Chrome no es compatible. Usa Safari.`,
  CHROME_ON_IOS_SECONDARY_COPY: `Esta versión de athenaTelehealth no es compatible con Chrome en iOS. Abre Safari o cámbiate a una computadora de escritorio.`,

  INTERNET_EXPLORER_PRIMARY_COPY: `Lo sentimos, Internet Explorer no es compatible. Usa Chrome o Edge.`,
  INTERNET_EXPLORER_SECONDARY_COPY: `Para proteger la seguridad de tu información de salud, athenaTelehealth no es compatible con Internet Explorer. Por favor, abre Chrome o Edge.`,

  UNSUPPORTED_CHROME_PRIMARY_COPY: `Lo sentimos, tu versión de Chrome no es compatible.`,
  UNSUPPORTED_CHROME_SECONDARY_COPY: `Descarga la última versión de Chrome.`,

  UNSUPPORTED_EDGE_PRIMARY_COPY: `Lo sentimos, tu versión de Microsoft Edge no es compatible.`,
  UNSUPPORTED_EDGE_SECONDARY_COPY: `Descarga la última versión de Microsoft Edge.`,

  UNSUPPORTED_FIREFOX_PRIMARY_COPY: `Lo sentimos, tu versión de Mozilla Firefox no es compatible.`,
  UNSUPPORTED_FIREFOX_SECONDARY_COPY: `Descarga la última versión de Mozilla Firefox.`,

  UNSUPPORTED_SAFARI_PRIMARY_COPY: `Lo sentimos, tu versión de Safari no es compatible.`,
  UNSUPPORTED_SAFARI_SECONDARY_COPY: `Descarga la última versión de Safari.`,

  UNSUPPORTED_SAMSUNG_INTERNET_PRIMARY_COPY: `Lo sentimos, tu versión de Samsung Internet Browser no es compatible.`,
  UNSUPPORTED_SAMSUNG_INTERNET_SECONDARY_COPY: `Descarga la última versión de Samsung Internet Browser.`,

  UNSUPPORTED_OPERA_PRIMARY_COPY: `Lo sentimos, tu versión de Opera no es compatible.`,
  UNSUPPORTED_OPERA_SECONDARY_COPY: `Descarga la última versión de Opera.`,

  UNSUPPORTED_BROWSER_PRIMARY_COPY: `Vaya, parece que tu navegador no es compatible.`,

  UNSUPPORTED_WINDOWS_BROWSER_SECONDARY_COPY: `Usa Chrome o Edge.`,
  UNSUPPORTED_MACOS_BROWSER_SECONDARY_COPY: `Usa Chrome o Safari.`,
  UNSUPPORTED_ANDROID_BROWSER_SECONDARY_COPY: `Usa Chrome.`,
  UNSUPPORTED_IOS_BROWSER_SECONDARY_COPY: `Usa Safari.`,

  APPOINTMENT_LINK_COPIED: `¡Enlace de invitación copiado!`,
  COPY_APPOINTMENT_LINK: `Copiar el enlace de invitación`,

  DEVICECHECK_LINK_COPIED: `Enlace de verificación del dispositivo copiado!`, // TODO: needs translation
  COPY_DEVICECHECK_LINK: `Copiar enlace de verificación del dispositivo`, // TODO: needs translation

  DOWNLOAD_SUPPORTED_BROWSER: `Descarga un navegador compatible:`,
  DOWNLOAD_SUPPORTED_BROWSER_IF_NEEDED: `Descarga un navegador compatible si es necesario:`,
  GOOGLE_CHROME_BROWSER: `Google Chrome`,
  MICROSOFT_EDGE_BROWSER: `Microsoft Edge`,
  FIREFOX_BROWSER: `Mozilla Firefox`,
  SAFARI_BROWSER: `Safari`,
  SAMSUNG_INTERNET: `Samsung Internet Browser`,
  OPERA_BROWSER: `Opera`,

  THEN_CTA_APPOINTMENT: `Luego regresa a tu cita otra vez.`,
  THEN_CTA_DEVICECHECK: `E inicia nuevamente la comprobación.`,
};
